import React from 'react';

//helper scripts
import * as wpScripts from '../../scripts/wpObjectScripts.js';
import StructureFoldersItem from './StructureFoldersItem.js';

const StructureFolders = ({ data, type }) => {    

    const boxes = data ? wpScripts.getBoxes(data.acf) : [];

    const foldersItems = boxes.map((listItem, index) => {
        return (
            <StructureFoldersItem 
                key={index} 
                {...listItem} 
                type={type}
            />
        );
    });

    return (
      <ul className="structure__folders">
          { foldersItems }
      </ul>
    );
};

export default StructureFolders;



// WEBPACK FOOTER //
// ./src/components/characteristics/StructureFolders.js